import { Component, effect, inject, model, OnInit } from '@angular/core';

import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucidePenLine, lucideTruck, lucideTrash2 } from '@ng-icons/lucide';

import { CrudService } from '../../core/services/crud.service';
import { SupplierFormComponent } from '../supplier-form/supplier-form.component';

@Component({
  selector: 'app-supplier-list',
  imports: [NgIcon, SupplierFormComponent],
  viewProviders: [
    provideIcons({ lucidePenLine, lucideTruck, lucideTrash2 }),
  ],
  templateUrl: './supplier-list.component.html',
  styles: ``,
})
export class SupplierListComponent implements OnInit {
  private crudService = inject(CrudService);
  suppliers: Array<any> = [];

  existingSupplier: any;

  showModal = model(false);

  constructor() {
    effect(() => {
      if (!this.showModal()) {
        this.getSuppliers();
      }
    });
  }

  ngOnInit(): void {
    // this.getSuppliers();
  }

  openModal() {
    this.existingSupplier = null;
    this.showModal.set(true);
  }

  getSuppliers() {
    this.crudService.getSuppliers().subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.suppliers = response.body;
        }
      },
    });
  }

  updateSupplier(supplier: any) {
    this.existingSupplier = supplier;
    this.showModal.set(true);
  }

  deleteSupplier(supplierId: number) {
    this.crudService.deleteSupplier(supplierId).subscribe({
      next: (response: any) => {
        if (response.ok) {
          // this.getCategories();
          this.getSuppliers();
        }
      },
    });
  }
}
